// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1_d3M","inputWrap":"Table_inputWrap__XhXjL","col":"Table_col__2hXPK","bmiTooltip":"Table_bmiTooltip__1tGFW"};